import React from 'react';
import { useForm } from 'react-hook-form';
import { AutocompleteField } from 'components/form';
import { Box, Button, Stack } from '@mui/material';
import { SendApplicationPortalConfig, SendApplicationPortalConfigFormValues } from '../types';
import { SelectOption } from 'global';
import { getFormDefaultValues } from '../lib';

interface Props {
  isLoading: boolean;
  portalConfigurationConfig: SendApplicationPortalConfig;
  lenderProfilesWithOcaOptions: SelectOption<string>[];
  onConfirm: (configuration: SendApplicationPortalConfigFormValues) => Promise<void>;
}

export const SendApplicationForm = ({
  isLoading,
  portalConfigurationConfig,
  lenderProfilesWithOcaOptions,
  onConfirm,
}: Props) => {
  const { control, handleSubmit } = useForm<SendApplicationPortalConfigFormValues>({
    defaultValues: getFormDefaultValues(portalConfigurationConfig, lenderProfilesWithOcaOptions),
  });

  return (
    <Box sx={{ display: 'grid', gridTemplateRows: '1fr auto', gap: '1rem', height: '100%' }}>
      <Stack gap="0.5rem">
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="0.5rem">
          <AutocompleteField<SelectOption<string>, true, SendApplicationPortalConfigFormValues>
            multiple
            control={control}
            options={lenderProfilesWithOcaOptions}
            name="excludedLenderProfiles"
            textFieldProps={{
              label: 'Select Lender Profiles',
              size: 'small',
              variant: 'outlined',
              helperText: 'Select Lender Profiles To Exclude From Lender Credit Application Template',
            }}
          />
        </Stack>
      </Stack>
      <Box>
        <Button loading={isLoading} variant="contained" onClick={handleSubmit(onConfirm)} size="small">
          Save
        </Button>
      </Box>
    </Box>
  );
};
